"use strict";

const { JsxEmit } = require("typescript");

var validateDirectiveCtrl = ["$scope", "Authentication", "$uibModal", "Form", '$translate', 'toast',
    function ($scope, Authentication, $uibModal, Form, $translate, toast) {
        var _this = this;
        this.isViewer = Authentication.isAuthorized("viewer");
        this.isAdmin = Authentication.isAuthorized("admin");
        this.isSupervisor = Authentication.isAuthorized("supervisor");
        this.isOwner = Authentication.isAuthorized("owner");
        _this.opened = window.location.hash.includes("validations?id=".concat(_this.item.id));
        _this.instances = _this.instances || 1;
        _this.item.validate = _this.item.validate || [];
        _this.type = _this.type || "distinct";
        _this.usersArray = _this.users || [];
        _this.currentUserTeamLeader = (_this.currentUserTeamLeader || false) && !this.isAdmin && !this.isOwner && !this.isSupervisor;
        _this.validateDefined = _this.validateDefined || [];
        _this.pages = _this.pages || [{ "fields": [] }];
        _this.allowCancelBoolean = _this.allowCancel || false;
        _this.allowCancelOptionList = _this.allowCancelOptions || [];
        _this.allowRejectOptionList = _this.allowRejectOptions || [];
        _this.pendingText = $translate.instant("DASHBOARD.DASH_VALIDATIONS.STATES.PENDING");
        _this.pendingLabel = _this.pendingText; // "Pendiente"
        if(_this.instances>1)
            _this.pendingLabel = _this.pendingText.concat(" ",_this.instances - _this.item.validate.length); // "Pendiente"
        _this.instanceValidateTeamLeader = false;
        const userInfo = Authentication.currentUserInfo();
        const userId = userInfo.id;
        _this.inline = _this.inline || false;

        if (!Array.isArray(_this.item.validate))
            _this.item.validate = _this.item.validate ? [_this.item.validate] : [];

        /*Conversion para cuando viene desde el ag-grid*/
        if (typeof (_this.usersArray) == "string")
            _this.usersArray = JSON.parse(_this.usersArray);
        if (typeof (_this.allowCancelBoolean) == "string")
            _this.allowCancelBoolean = JSON.parse(_this.allowCancelBoolean) && _this.item.validate.length > 0;
        if (typeof (_this.allowCancelOptionList) == "string")
            _this.allowCancelOptionList = JSON.parse(_this.allowCancelOptionList);
        if (typeof (_this.allowRejectOptionList) == "string")
            _this.allowRejectOptionList = JSON.parse(_this.allowRejectOptionList);

        if (typeof (_this.validateDefined) == "string")
            _this.validateDefined = JSON.parse(_this.validateDefined);
        /*END Conversion para cuando viene desde el ag-grid*/
        if (_this.type == "instance-defined" && _this.item.validate.length < _this.validateDefined.length) {
            // _this.pendingLabel = "Pendiente ".concat(_this.validateDefined[_this.item.validate.length].input || ("#" + (_this.item.validate.length + 1)));
            _this.pendingLabel = _this.validateDefined[_this.item.validate.length].input || (_this.pendingText + " #" + (_this.item.validate.length + 1)); // "Pendiente"

            _this.item.validate = _this.item.validate || [];
            
            _this.usersArray = _this.validateDefined[_this.item.validate.length]?.validate_users ? _this.validateDefined[_this.item.validate.length]?.validate_users : [];
            _this.instanceValidateTeamLeader = _this.validateDefined[_this.item.validate.length]?.validate_teamleader == true;
            _this.prevInstanceValidateTeamLeader = _this.item.validate.length>0? _this.validateDefined[_this.item.validate.length-1]?.validate_teamleader == true : false;
            if (Array.isArray(_this.item.validate_tagsFromMask) && _this.item.validate.length ==0)
                _this.usersArray = _this.usersArray.concat(_this.item.validate_tagsFromMask);
            else if (_this.validateDefined[_this.item.validate.length].validate_tagsMask?.length>0  && Array.isArray(userInfo.tags) ){
                const regex = /\$\{([^|}]+)(?:\|[^}]*)?\}/g;
                for (let mask of _this.validateDefined[_this.item.validate.length].validate_tagsMask) {
                    mask = mask.replace(regex, (match, fieldId) => {
                        console.log(`Hash encontrado: ${fieldId}`); // Puedes registrar el hash antes de reemplazarlo
                        return (`${_this.item.payload[fieldId]?.value?.split("|")[0]?.replace("*", "")}`); // Mantiene el formato `${}` con el nuevo valor
                    });
                    let tag = userInfo.tags.find(t => t.name.includes(mask));
                    if (tag)
                        _this.usersArray.push({ id: tag.id, name: tag.name, mask: mask });
                }
            }

            if (!_this.isAdmin && _this.item.validate.length < _this.validateDefined.length) {
                _this.pendingLabel = _this.validateDefined[_this.item.validate.length].input || (_this.pendingText + " #" + (_this.item.validate.length + 1)); // "Pendiente" o "Cancelar"
                if (_this.item.validate.length > 0 &&
                    _this.item.validate[_this.item.validate.length - 1].user._id == userId &&
                    !(_this.usersArray.includes(userId)) &&
                    !(_this.usersArray.some(u => u.id == userId)) &&
                    !(userInfo.tags?.some(t => (_this.usersArray.map(u => u.id)).includes(t.id)))) {
                    _this.pendingLabel = "Cancelar";
                    _this.item.onlyCancel = true;
                }
            }
        }
        _this.reloadStatus = (result) => {
            // console.log('reloadStatus', result)
            if (result.action == 'cancel') {
                if (typeof result.status == 'string' && result.status == 'error') {
                    _this.item = _this.item;
                } else {
                    if (typeof result.status == 'object') {
                        _this.item.validate = result.status?.item?.validate;
                        _this.item.validate_canceled = result.status?.item?.validate_canceled;
                    } else {
                        _this.item = result.item ?? _this.item;
                    }
                }
                _this.isPending = checkIfPending();
                _this.canValidate = checkIfcanValidate()
            } else
                if (result.action == 'save') {
                    if (result.state?.toLowerCase() == 'accept' || result.state?.toLowerCase() == 'reject' || result.state?.toLowerCase() == 'ok') {
                        if (result.status?.status?.toLowerCase() == 'ok') {
                            this.deleteItem({ id: _this.item.id });
                        } else {
                            _this.isPending = checkIfPending();
                            _this.canValidate = checkIfcanValidate()
                        }
                    } else {
                        _this.isPending = checkIfPending();
                        _this.canValidate = checkIfcanValidate()
                    }
                } else {
                    console.log('Error reloadStatus')
                }
        }
        function checkIfPending() {
            if (_this.item.validate?.find((el) => el.state == "REJECT") != undefined)
                return false;
            if (_this.item.validate?.length < _this.instances) return true;
            return false;
        }
        function checkIfcanValidate() {
            if (_this.currentUserTeamLeader && _this.instanceValidateTeamLeader) {
                return true;
            }
            if (_this.isViewer || (_this.currentUserTeamLeader && !_this.instanceValidateTeamLeader &&  !_this.prevInstanceValidateTeamLeader)) return false;
            if (
                !_this.isAdmin &&
                _this.usersArray.length > 0 &&
                _this.usersArray.includes(userId) == false &&
                _this.usersArray.some(u => u.id == userId) == false &&
                !userInfo.tags?.some(t => (_this.usersArray.map(u => u.id)).includes(t.id))
            ) {
                if (_this.item.validate[_this.item.validate.length - 1]?.user._id != userId) {
                    return false; //no figura en la lista de los posibles usuarios, y no es el último que validó
                }
            }
            if (_this.item.validate.length == 0 || _this.allowCancelBoolean || _this.type == "indistinct")
                return true;
            if (
                _this.type == "distinct" &&
                _this.item.validate.find((el) => el.user._id == userId) == undefined
            ) {
                return true;
            }
            if (
                _this.type == "not-consecutive" &&
                _this.item.validate[_this.item.validate.length - 1].user._id != userId
            ) {
                return true;
            }
            if (_this.type == "instance-defined") {
                return true;
            }
            return false;
        }
        _this.isPending = checkIfPending();
        _this.canValidate = (_this.isPending || _this.allowCancelBoolean) && checkIfcanValidate();

        _this.getValidationStateText = function () {
            const lastValidation = _this.item.validate[_this.item.validate.length - 1];
            if (lastValidation) {
                if (lastValidation.state === 'OK') {
                    return $translate.instant("DASHBOARD.DASH_VALIDATIONS.STATES.OK");
                } else if (lastValidation.state === 'REJECT') {
                    return $translate.instant("DASHBOARD.DASH_VALIDATIONS.STATES.REJECT");
                } else if (lastValidation.user.id === userId) {
                    _this.item = {
                        ..._this.item,
                        onlyCancel: true,
                    }
                    return $translate.instant("DASHBOARD.DASH_VALIDATIONS.STATES.REJECT");
                } else {
                    return lastValidation.state;
                }
            }
            return '';
        };

        this.openDetailValidate = function (item) {
            // Etapa que el usuario veía al hacer click (antes del refetch). Evita saltar de etapa si otra pestaña ya validó.
            const expectedStage = Array.isArray(_this.item.validate) ? _this.item.validate.length : 0;
            Form.prototype$__findById__items({ id: item.formId, fk: item.id })
                .$promise
                .then(freshItem => {
                    const freshValidate = Array.isArray(freshItem.validate)
                        ? freshItem.validate
                        : (freshItem.validate ? [freshItem.validate] : []);
                    const freshStage = freshValidate.length;

                    if (freshStage !== expectedStage) {
                        // Otra sesión/pestaña ya avanzó la validación: no abrir el modal en la etapa nueva.
                        _this.item.validate = freshValidate;
                        if (freshItem.validate_canceled !== undefined) {
                            _this.item.validate_canceled = freshItem.validate_canceled;
                        }
                        _this.item.onlyCancel = false;
                        _this.isPending = checkIfPending();
                        _this.canValidate = false;
                        if (_this.type == "instance-defined" && freshStage < _this.validateDefined.length) {
                            _this.pendingLabel = _this.validateDefined[freshStage].input
                                || (_this.pendingText + " #" + (freshStage + 1));
                        } else if (!_this.isPending) {
                            _this.pendingLabel = _this.getValidationStateText();
                        }
                        toast.error($translate.instant('DASHBOARD.DASH_VALIDATIONS.STAGE_CHANGED'));
                        return;
                    }

                    freshItem.validate = freshValidate;
                    $uibModal.open({
                        animation: true,
                        controller: require("./validateDirectiveModal"),
                        templateUrl: "directives/validateDirectiveModal.html",
                        controllerAs: "modal",
                        size: "xlg",
                        windowClass: "dialog",
                        bindToController: true,
                        resolve: {
                            item: function () {
                                return freshItem;
                            },
                            pages: function () {
                                return typeof (_this.pages) == "string" ? JSON.parse(_this.pages) : _this.pages;
                            },
                            formValidate: function () {
                                return {
                                    allowCancel: _this.allowCancelBoolean,
                                    allowCancelOptionList: _this.allowCancelOptionList,
                                    allowRejectOptionList: _this.allowRejectOptionList,
                                    type: _this.type,
                                    instances: _this.instances,
                                    users: _this.usersArray,
                                    validate_defined: (typeof (_this.validateDefined) == "string" ? JSON.parse(_this.validateDefined) : _this.validateDefined),
                                    onlyCancel: _this.item.onlyCancel || false,
                                    // Fija la etapa al momento del click/apertura (defensa ante race al guardar)
                                    validationStage: expectedStage,
                                }
                            },
                            canValidateTeamLeader: function () {
                                return _this.currentUserTeamLeader && _this.instanceValidateTeamLeader
                            },
                            canValidateTeamLeaderPrev: function () { // Instancia anterior
                                return _this.prevInstanceValidateTeamLeader
                            },
                        },
                    }).result.then((result) => {
                        _this.reloadStatus(result)
                    });
                });
        };

        this.openHistory = function (item) {
            const canSeeAdditionalHistoryFields = _this.isAdmin || _this.isOwner || _this.isSupervisor;
            $uibModal.open({
                animation: true,
                templateUrl: 'directives/validateHistoryGraphModal.html',
                controller: require("./validateDirectiveHistoryModal"),
                controllerAs: "modal",
                size: "xlg",
                windowClass: "dialog",
                bindToController: true,
                resolve: {
                    item: () => item,
                    pages: () => typeof (_this.pages) == "string" ? JSON.parse(_this.pages) : (_this.pages || []),
                    formDefinition: ["Form", function (Form) {
                        const formId = item?.formId;
                        if (!formId) return null;
                        return Form.find({
                            filter: {
                                where: { id: formId },
                                fields: ["id", "name", "validate_pages", "pages"],
                            },
                        }).$promise
                            .then(function (forms) { return (forms && forms[0]) || null; })
                            .catch(function () { return null; });
                    }],
                    canSeeAdditionalHistoryFields: () => canSeeAdditionalHistoryFields,
                }
            }).result.then((result) => {
            }, function () { //dismiss
            });
        };

        if (_this.opened)
            _this.openDetailValidate(_this.item);
    }];

module.exports = function () {
    return {
        restrict: "E",
        scope: {
            item: "=",
            type: "=",
            instances: "=",
            pages: "=",
            users: "=",
            // currentUserId: "=",
            currentUserTeamLeader: "=",
            allowCancel: "=",
            allowCancelOptions: "=",
            allowRejectOptions: "=",
            validateDefined: "=",
            deleteItem: "&",
            inline: "=",
        },
        controller: validateDirectiveCtrl,
        controllerAs: "ctrl",
        bindToController: true,
        templateUrl: "directives/validateDirective.html",
    };
};
